"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.enrichVideosInfo = exports.getFullJobStatus = void 0;
var apiService_1 = __importDefault(require("@common/services/apiService"));
var _i18n_1 = __importDefault(require("@i18n"));
var addInfoToImages_1 = __importDefault(require("@utils/addInfoToImages"));
var extractDomainFromUrl_1 = __importDefault(require("@utils/extractDomainFromUrl"));
var getImageAugNotices_1 = __importDefault(require("@utils/getImageAugNotices"));
var groupBy_1 = __importDefault(require("@utils/groupBy"));
var lodash_1 = __importDefault(require("lodash"));
var generateHash_1 = require("@/react-app/features/mediaGallery/utils/generateHash");
var getFullJobStatus = function (status, actorDomain) {
    if (status === 'no decision') {
        return 'no-decision';
    }
    if (lodash_1.default.includes(['approved', 'refused'], status)) {
        var mapping = { client: 'remotely', agent: 'manual', processor: 'auto' };
        return "".concat(mapping[actorDomain], "-").concat(status);
    }
    return status;
};
exports.getFullJobStatus = getFullJobStatus;
var getNotice = function (processingResults) {
    var notices = [];
    lodash_1.default.forEach(processingResults, function (result) {
        var notice = result.notice;
        if (lodash_1.default.get(result, 'notice.enabled')) {
            notices.push(lodash_1.default.assign({}, {
                message: notice === null || notice === void 0 ? void 0 : notice.text,
                rule: result.rule,
                severity: (notice === null || notice === void 0 ? void 0 : notice.severity) ? notice.severity.toLowerCase() : '',
            }));
        }
    });
    return notices;
};
var replaceDecisionSetLabel = function (groupedDecisionSet) {
    if (!!groupedDecisionSet && groupedDecisionSet.length === 1) {
        groupedDecisionSet[0].key = _i18n_1.default.t('ITEM.DEFAULT_REFUSE_BUTTON_LABEL');
    }
    return groupedDecisionSet;
};
var isDecisionMade = function (status) {
    return ['refused', 'approved', 'no decision'].indexOf(status) !== -1;
};
// [TO-DO] refactor this function when working on manual moderation queue.
// we should not set type and reason to null in case of deferred or reviewable
// but it breaks the progress bar on the bottom of the page(displaying 1 2 3 4 5 6 with color of decision made)
var setCurrentDecision = function (status, isPreApprove, refusalReason) {
    if (status === 'deferred' || status === 'reviewable') {
        return { type: isPreApprove ? 'approve' : null, reason: null };
    }
    if (status === 'refused') {
        return { type: 'refuse', reason: refusalReason };
    }
    if (status === 'approved') {
        return { type: 'approve' };
    }
};
var isJobPostReviewed = function (history) {
    if (!Array.isArray(history)) {
        return false;
    }
    var numberOfDecisionMade = 0;
    history.forEach(function (historyItem) {
        if (!historyItem || !historyItem.meta || !historyItem.meta.status) {
            return;
        }
        if (isDecisionMade(historyItem.meta.status)) {
            numberOfDecisionMade++;
        }
    });
    return numberOfDecisionMade > 1;
};
var getUserDefinedLocationText = function (address) {
    if (!address) {
        return;
    }
    var info = [address.city, address.postcode, address.countryCode];
    return info.filter(function (item) { return !!item; }).join(', ') + (address.region ? " (".concat(address.region, ")") : '');
};
var getGeolocationText = function (geolocation) {
    var info = [lodash_1.default.get(geolocation, 'city.name'), lodash_1.default.get(geolocation, 'postal.code'), lodash_1.default.get(geolocation, 'country.iso_code')];
    return info.filter(function (item) { return !!item; }).join(', ') || 'N/A';
};
// TO DO find how render html tag in translation file outside react component
var getOpenInDomainText = function (url) {
    return _i18n_1.default.t('SEARCH.ITEM.OPEN_IN_WEBSITE_REACT', { WEBSITE: (0, extractDomainFromUrl_1.default)(url) || url });
};
var addImagesInfoToHistory = function (history, imagesInfo) {
    var crawlingCompletionTime = lodash_1.default.get(imagesInfo, 'crawlingCompletionTime');
    var content = lodash_1.default.get(imagesInfo, 'content');
    if (content && crawlingCompletionTime && content.length) {
        var mergedHistory = __spreadArray(__spreadArray([], __read(history), false), [
            { timestamp: crawlingCompletionTime, meta: { status: 'image-fetched' }, actor: { domain: 'processor' }, content: content },
        ], false);
        return mergedHistory;
    }
    return history;
};
var enrichVideosInfo = function (videos, videosInfoContent) {
    return videosInfoContent.map(function (video, index) {
        var deletedVid = videos[index];
        return 'deleted' in deletedVid && deletedVid.deleted !== undefined
            ? __assign(__assign({}, video), { deleted: deletedVid.deleted === true, src: videos[index].src }) : __assign(__assign({}, video), { src: videos[index].src });
    });
};
exports.enrichVideosInfo = enrichVideosInfo;
var Job = /** @class */ (function () {
    function Job(jobData) {
        if (jobData) {
            this.setData(jobData);
        }
    }
    Job.prototype.setDataWithJobAndDecision = function (data, decisionSet, isPreApprove) {
        this.setData({ ad: data, decisionSet: decisionSet }, isPreApprove);
    };
    Job.prototype.setData = function (data, isPreApprove) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (data.decisionSet)
            this.decisionSet = replaceDecisionSetLabel((0, groupBy_1.default)(data.decisionSet, 'categoryName'));
        this.ad = data.ad;
        this.focusMe = false;
        var processingResults = data.ad.current.processingResults;
        this.notices = getNotice(processingResults);
        this.selectedDecision = setCurrentDecision(this.ad.current.meta.status, isPreApprove, (_a = this.ad.current.meta.decisions) === null || _a === void 0 ? void 0 : _a[0]);
        // TO DO FIX the api https://besedo.atlassian.net/browse/IMP-9195 then adapt the front end
        this.selectedFeedbackIds = (((_d = (_c = (_b = this === null || this === void 0 ? void 0 : this.ad) === null || _b === void 0 ? void 0 : _b.current) === null || _c === void 0 ? void 0 : _c.meta) === null || _d === void 0 ? void 0 : _d.feedback) || []).map(function (f) { return f.id; });
        this.isDecisionMade = isDecisionMade(lodash_1.default.get(this.ad, 'current.meta.status'));
        this.isPostReviewed = isJobPostReviewed(this.ad.history);
        var images = ((_g = (_f = (_e = this.ad) === null || _e === void 0 ? void 0 : _e.current) === null || _f === void 0 ? void 0 : _f.content) === null || _g === void 0 ? void 0 : _g.images) || [];
        var videos = ((_k = (_j = (_h = this.ad) === null || _h === void 0 ? void 0 : _h.current) === null || _j === void 0 ? void 0 : _j.content) === null || _k === void 0 ? void 0 : _k.videos) || [];
        var videosInfoContent = ((_l = this.ad.videosInfo) === null || _l === void 0 ? void 0 : _l.content) || [];
        if (videos) {
            var enrichedVideosInfoContent = (0, exports.enrichVideosInfo)(videos, videosInfoContent);
            this.videosMetadataArray = enrichedVideosInfoContent.map(function (item, index) { return (__assign(__assign({}, item), { id: (0, generateHash_1.generateHash)("".concat(item.url).concat(index)) })); });
        }
        if (images) {
            var imagesInfoContent = ((_m = this.ad.imagesInfo) === null || _m === void 0 ? void 0 : _m.content) || [];
            var currentMetaImageAug = (_o = this.ad.current) === null || _o === void 0 ? void 0 : _o.meta.imageAug;
            var enrichedImagesInfoContent = (0, addInfoToImages_1.default)(images, this.ad.remoteId.domain, this.ad.id, imagesInfoContent, currentMetaImageAug);
            this.generatedNotices = (0, getImageAugNotices_1.default)(enrichedImagesInfoContent);
            this.imagesMetadataArray = enrichedImagesInfoContent.map(function (item, index) { return (__assign(__assign({}, item), { id: (0, generateHash_1.generateHash)("".concat(item.src).concat(index)) })); });
        }
        this.userDefinedLocationText = getUserDefinedLocationText(lodash_1.default.get(this.ad, 'current.content.address'));
        this.geolocationText = getGeolocationText(lodash_1.default.get(this.ad, 'current.meta.geolocation'));
        this.openItemIdAdminUrlTooltip = getOpenInDomainText(lodash_1.default.get(this.ad, 'current.content.adminUrl'));
        // Api _.get(this.ad, 'current.content.url') can return null | undefined | string
        this.openItemIdUrlTooltip = getOpenInDomainText(lodash_1.default.get(this.ad, 'current.content.url') || undefined);
        this.openUserIdTooltip = getOpenInDomainText(lodash_1.default.get(this.ad, 'current.user.adminUrl'));
        this.titleWithPlaceholder =
            lodash_1.default.get(this.ad, 'current.content.title') || "".concat(_i18n_1.default.t('ITEM.ITEM_ID_PLACEHOLDER_REACT', { ITEM_ID: this.ad.remoteId.id }));
        this.hasTitleField = this.ad.current.content && Object.prototype.hasOwnProperty.call(this.ad.current.content, 'title');
        this.hasBodyField = this.ad.current.content && Object.prototype.hasOwnProperty.call(this.ad.current.content, 'body');
        var videosLength = videos ? videos.length : 0;
        var imagesLength = images ? images.length : 0;
        this.mediaCount = imagesLength + videosLength;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        this.ad = __assign(__assign({}, this.ad), { history: addImagesInfoToHistory(this.ad.history, this.ad.imagesInfo) });
    };
    Job.prototype.load = function (domain, id) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, apiService_1.default.getAd({ domain: domain, id: id })];
                    case 1:
                        data = (_a.sent()).data;
                        this.setData(data);
                        return [2 /*return*/];
                }
            });
        });
    };
    Job.prototype.getAd = function () {
        return this.ad;
    };
    Job.prototype.updateAd = function (ad) {
        this.ad = ad;
    };
    Job.prototype.getImages = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this === null || this === void 0 ? void 0 : this.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.images;
    };
    Job.prototype.hasImages = function () {
        var images = this.getImages();
        return images ? images.length > 0 : false;
    };
    Job.prototype.getVideos = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.videos;
    };
    Job.prototype.hasVideos = function () {
        var videos = this.getVideos();
        return videos ? videos.length > 0 : false;
    };
    Job.prototype.getJobTitle = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.title;
    };
    Job.prototype.getJobBody = function () {
        var _a, _b, _c;
        return (_c = (_b = (_a = this.ad) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.content) === null || _c === void 0 ? void 0 : _c.body;
    };
    Job.prototype.getDate = function () {
        var _a;
        return new Date(((_a = this.ad) === null || _a === void 0 ? void 0 : _a.current.meta.timeEntered) || 0);
    };
    Job.prototype.getStatus = function () {
        var _a;
        var status = (_a = this.ad) === null || _a === void 0 ? void 0 : _a.current.meta.status;
        switch (status) {
            case 'new':
                return 'processing';
            case 'deferred':
                return 'escalated';
            default:
                return status;
        }
    };
    Job.prototype.getFirstVideoUrl = function (index) {
        if (index === void 0) { index = 0; }
        var videos = this.getVideos();
        if (videos && videos.length > index) {
            return videos[index].src;
        }
        return '';
    };
    Job.prototype.getOpenItemIdUrlTooltip = function () {
        return this.openItemIdUrlTooltip;
    };
    Job.prototype.getOpenItemIdAdminUrlTooltip = function () {
        return this.openItemIdAdminUrlTooltip;
    };
    Job.prototype.getOpenUserIdTooltip = function () {
        return this.openUserIdTooltip;
    };
    Job.prototype.getMediaCount = function () {
        return this.mediaCount;
    };
    Job.prototype.setShowBoundingBox = function (newShowBoundingBox) {
        this.showBoundingBox = newShowBoundingBox;
    };
    Job.prototype.setSelectedInSearchView = function (selectedInSearchView) {
        this.selectedInSearchView = selectedInSearchView;
    };
    Job.prototype.setSelectedDecision = function (selectedDecision) {
        this.selectedDecision = selectedDecision;
    };
    return Job;
}());
exports.default = Job;
